import React from 'react';

const SvgLc = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LC_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="LC_svg__d" d="M14 2.667l6 14.666H8z" />
      <filter
        x="-4.2%"
        y="-3.4%"
        width="108.3%"
        height="113.6%"
        filterUnits="objectBoundingBox"
        id="LC_svg__c"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LC_svg__b" fill="#fff">
        <use xlinkHref="#LC_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#LC_svg__a" />
      <path fill="#86D7FF" mask="url(#LC_svg__b)" d="M0 0h28v20H0z" />
      <g mask="url(#LC_svg__b)">
        <use fill="#000" filter="url(#LC_svg__c)" xlinkHref="#LC_svg__d" />
        <use fill="#FFF" xlinkHref="#LC_svg__d" />
      </g>
      <path
        fill="#262626"
        mask="url(#LC_svg__b)"
        d="M14 5.333l4.667 12H9.333z"
      />
      <path fill="#FFDA57" mask="url(#LC_svg__b)" d="M14 9.333l6 8H8z" />
    </g>
  </svg>
);

export default SvgLc;
